const docReady = (fn) => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

const addClassToElement = (element, className) => {
  if (element) {
    element.classList.add(className);
  }
};

// Function to remove class from an element
const removeClassFromElement = (element, className) => {
  if (element) {
    element.classList.remove(className);
  }
};

const body = document.querySelector('html,body');
const closeModal = document.getElementById('close--bannerModal');
const closeBanner = document.querySelectorAll('.close--banner');
const modal = document.querySelector('.modal_banner');
const modalOverlay = document.querySelector('.modal_bg_overlay');
const bannerLink = document.querySelector('.bannerLink__no--modal');
const bannerLinkAttr = document.querySelector('.bannerLink');
const bannersticky = document.querySelector('.bannerNotification.banner-isSticky-true');
const bannerfalse = document.querySelector('.bannerNotification.banner-isSticky-false');
const header = document.querySelector('.site-header');

if (header.classList.contains('site-header--ventures-transparent')) {
  addClassToElement(bannersticky, 'header-transparent');
  addClassToElement(bannerfalse, 'header-transparent');
} else {
  removeClassFromElement(bannersticky, 'header-transparent');
  removeClassFromElement(bannerfalse, 'header-transparent');
}

docReady(() => {
  if (closeModal) {
    closeModal.addEventListener('click', () => {
      modal.classList.remove('active');
      modalOverlay.classList.remove('active');
      body.style.overflow = 'auto';
    });
  }

  if (bannerLink) {
    bannerLink.addEventListener('click', (e) => {
      e.preventDefault();
      modal.classList.add('active');
      modalOverlay.classList.add('active');
      body.style.overflow = 'hidden';
    });
  }

  if (closeBanner.length > 0) {
    Array.from(closeBanner).forEach((closeBtn) => {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const { target } = e;
        target.closest('.bannerNotification').classList.add('d-none');
      });
    });
  }

  if (bannersticky !== null && window.scrollY === 0) {
    bannersticky.classList.remove('scrolled');
  }

  window.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY;

    if (scrollPosition > 0) {
      addClassToElement(bannerLink, 'scrolled');
      addClassToElement(bannersticky, 'scrolled');
      addClassToElement(bannerLinkAttr, 'scrolled');
    } else {
      removeClassFromElement(bannerLink, 'scrolled');
      removeClassFromElement(bannersticky, 'scrolled');
      removeClassFromElement(bannerLinkAttr, 'scrolled');
    }
  });
});
